import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { SetPreconfigureDateRequest, ScheduleEnablementRequest } from '../interfaces/preconfigure-migration-dto';

@Injectable({
    providedIn: 'root'
})
export class PreconfigureMigrationService {
    private http = inject(HttpClient);


    private baseUrl = environment.apiUrl + '/api/v1/organization-migration';

    bulkSetPreconfigureDate(request: SetPreconfigureDateRequest): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/preconfigure-migration`, request)
            .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
    }

    bulkSetEnablementDate(request: ScheduleEnablementRequest): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/schedule-enablement`, request)
            .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
    }
}
